module.exports = __webpack_public_path__ + "img/10_newModelWorker_lh.a8a12d4e.png";